import { ref } from 'vue'
import * as Sentry from '@sentry/vue'
import { FindexClient } from '@/integrations/findex'

const isFmpAvailable = ref<boolean | null>(null)

let fmpChecked = false

const checkFmp = async () => {
  if (fmpChecked) return
  fmpChecked = true
  try {
    isFmpAvailable.value = await FindexClient.fmpHealthCheck()
  } catch (e) {
    fmpChecked = false
    isFmpAvailable.value = false
    Sentry.captureException(e)
  }
}

export const useApiHealth = () => {
  checkFmp().catch((e) => Sentry.captureException(e))

  return {
    isFmpAvailable
  }
}
